import { Link } from 'react-router-dom'

import { COMPANY_NUMBER, ENTITY, supportEmail } from '../legal'

/** Shown on every page, signed in or out, so the legal pages are always one click away. */
export default function SiteFooter() {
  const email = supportEmail()
  return (
    <footer className="site">
      <div className="inner">
        <span>
          © {ENTITY} · Company number {COMPANY_NUMBER}
        </span>
        <nav aria-label="Legal">
          <Link to="/terms">Terms</Link>
          <Link to="/privacy">Privacy</Link>
          <a href={`mailto:${email}`}>Support</a>
        </nav>
      </div>
    </footer>
  )
}
